module.exports = __webpack_public_path__ + "static/media/goodfrac_output.89b100d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/info/goodfrac_output.png
// module id = 2356
// module chunks = 0